import { useFormContext } from 'react-hook-form';

import { FormTextField } from '@sbv-clients/ui-forms';
import { Button, Grid } from '@sbv-clients/ui-shared';
import { formatPhone } from '@sbv-clients/util-misc';

import { BackToSignIn } from '../../components/back-to-sign-in';
import {
  authButtonSx,
  authFieldSx,
  authLabelSx,
} from '../../styles/auth-form.styles';

export const VerifyPhoneFormBody = () => {
  const { formState, setValue } = useFormContext();
  const { isSubmitting } = formState;

  return (
    <Grid container spacing={4}>
      <Grid size={12}>
        <FormTextField
          density={'comfortable'}
          fullWidth
          name="phoneNumber"
          type="text"
          label="Phone number"
          labelSx={authLabelSx}
          sx={authFieldSx}
          onChange={(e) => {
            const formatted = formatPhone(e.target.value);
            setValue('phoneNumber', formatted);
          }}
        />
      </Grid>
      <Grid size={12} pt={10}>
        <Button
          fullWidth
          type="submit"
          variant="contained"
          size="large"
          sx={authButtonSx}
          disabled={isSubmitting}
        >
          Confirm
        </Button>
        <BackToSignIn />
      </Grid>
    </Grid>
  );
};
